import React, { useState } from "react";
import Select from "react-select";
import AddItemButton from "../../common/components/base/AddItemButton";
import ItemsGrid from "../../common/components/widgets/ItemsGrid";
import LoadingSpinner from "../../common/components/LoadingSpinner/LoadingSpinner";
import Swal from "sweetalert2";
import { useRegions } from "../../hooks/useRegions";
import { useJobProfilesByRegion } from "../../hooks/useJobProfilesByRegion";
import { useDeleteJobProfile } from "../../hooks/useDeleteJobProfile";
import ProfessionalQualificationModal from "./ProfessionalQualificationModal";

const columns = ["name", "region", "action"];
const columnsName = ["Name", "Region", "Actions"];

const ProfessionalQualificationsTab = () => {
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const { data: regionsData } = useRegions();
  const { data: jobProfilesData, isFetching: loading } = useJobProfilesByRegion(
    selectedRegion?.value
  );
  const deleteJobProfileMutation = useDeleteJobProfile();

  const regions = regionsData?.regions || [];
  const jobProfiles = jobProfilesData?.jobProfiles || [];

  const regionOptions = regions.map((r) => ({
    value: r.key || r._id,
    label: r.name,
  }));

  const items = jobProfiles.map((jp) => ({
    ...jp,
    region: selectedRegion?.label || "",
  }));

  const handleCreate = () => {
    setSelectedItem(null);
    setIsUpdate(false);
    setOpenModal(true);
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsUpdate(true);
    setOpenModal(true);
  };

  const handleDelete = (item) => {
    Swal.fire({
      title: "Are you sure you want to delete this Professional Qualification?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
    }).then((result) => {
      if (result.value === true) {
        deleteJobProfileMutation.mutate(
          { id: item.key || item._id },
          {
            onSuccess: () => {
              Swal.fire({
                icon: "success",
                title: "Professional Qualification deleted!",
                showConfirmButton: false,
                timer: 1500,
              });
            },
            onError: (error) => {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: error?.response?.data?.message || error.message || "Cannot delete: item may be referenced",
                showConfirmButton: true,
              });
            },
          }
        );
      }
    });
  };

  return (
    <div>
      <AddItemButton OnClick={handleCreate} disabled={openModal} />

      <div className="row" style={{ marginBottom: "16px", marginTop: "16px" }}>
        <div className="col-sm-12 col-md-4">
          <Select
            value={selectedRegion}
            onChange={(value) => setSelectedRegion(value)}
            options={regionOptions}
            isClearable
            placeholder="Select Region"
          />
        </div>
      </div>

      {loading && <LoadingSpinner />}

      {selectedRegion && !loading && (
        <ItemsGrid
          columns={columns}
          columnsName={columnsName}
          items={items}
          edit={(index, value) => handleEdit(value)}
          remove={(index, value) => handleDelete(value)}
          title="Professional Qualifications"
          rowsPerPage={10}
          pagination={true}
        />
      )}

      <ProfessionalQualificationModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        isUpdate={isUpdate}
        item={selectedItem}
        regionOptions={regionOptions}
        defaultRegion={selectedRegion}
      />
    </div>
  );
};

export default ProfessionalQualificationsTab;
